import { render } from "./CorridoringDisplay.vue?vue&type=template&id=f4ac43b2"
import script from "./CorridoringDisplay.vue?vue&type=script&lang=js"
export * from "./CorridoringDisplay.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__